<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-01-05 11:10:06
-->
<template>
  <div>
    <el-card shadow="hover">
      <slot></slot>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ComCard'
}
</script>

<style lang="scss" scoped></style>
